const REACT_APP_OKTA_INTERNAL_CLIENT_ID = process.env.REACT_APP_OKTA_INTERNAL_CLIENT_ID ?? '';
const REACT_APP_OKTA_INTERNAL_ISSUER = process.env.REACT_APP_OKTA_INTERNAL_ISSUER ?? '';
const REACT_APP_OKTA_EXTENAL_CLIENT_ID = process.env.REACT_APP_OKTA_EXTENAL_CLIENT_ID ?? '';
const REACT_APP_OKTA_EXTERNAL_ISSUER = process.env.REACT_APP_OKTA_EXTERNAL_ISSUER ?? '';
const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;


export const oktaConfig = {
  clientId: REACT_APP_OKTA_INTERNAL_CLIENT_ID,
  issuer: REACT_APP_OKTA_INTERNAL_ISSUER,
  redirectUri: REACT_APP_BASE_URL + "/login/callback",
  scopes: ["openid", "email", "profile"],
  pkce: true,
  disableHttpsCheck: false,
  tokenManager: {
    autoRenew: true,
    secure: true,
    expireEarlySeconds: 5 * 60
  }
};

export const oktaExternalConfig = {
  clientId: REACT_APP_OKTA_EXTENAL_CLIENT_ID,
  issuer: REACT_APP_OKTA_EXTERNAL_ISSUER,
  redirectUri: REACT_APP_BASE_URL + "/login/callback",
  scopes: ["openid", "email", "profile"],
  pkce: true,
  disableHttpsCheck: false,
  tokenManager: {
    autoRenew: true,
    secure: true,
    expireEarlySeconds: 5 * 60
  }
};